<template>
  <div class="footer mainFooter d-flex justify-content-center py-5">
    <div class="d-flex flex-column align-items-end pr-5 border-right">
      <div>ห้อง 3c15 ชั้น 3 เลขที่ 723 อาคารศุภาคาร</div>
      <div>ถนนเจริญนคร แขวงคลองต้นไทร</div>
      <div>เขตคลองสาน กรุงเทพ 10600</div>
    </div>
    <div class="d-flex align-items-start ms-5">
      <div class="me-3">
        <img src="../../public/logo_i-net.png" alt="" style="height: 60px" />
      </div>
      <div class="text-start">
        <strong>มูลนิธิอินเทอร์เน็ตร่วมพัฒนาไทย</strong>
        <p style="color: #18b5d9; margin: 0">
          Internet Foundation for the Development of Thailand
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "mainFooter",
};
</script>
<style lang="scss">
.mainFooter {
  background: linear-gradient(
    100deg,
    rgba(4, 17, 89, 1) 0%,
    rgba(27, 98, 191, 1) 100%
  );
  color: #fff;
  text-align: center;
}
</style>
